export const DEFAULT_TABLE_ACTION_COLUMN_WIDTH = 120
